module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Italic.acd6b502.woff";